import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["collaboratorsContainer", "submitBtn", "errors"]
  static values = { updateUrl: String }

  addCard() {
    const container = this.collaboratorsContainerTarget
    const firstCard = container.querySelector("[data-controller*='collaborator-card']")
    if (firstCard) {
      const clone = firstCard.cloneNode(true)
      clone.querySelectorAll("input").forEach(input => { input.value = "" })
      clone.querySelectorAll("[data-collaborator-card-target='memberChips']").forEach(el => { el.innerHTML = "" })
      delete clone.dataset.collaboratorCardInitialCompanyIdValue
      delete clone.dataset.collaboratorCardInitialCompanyNameValue
      delete clone.dataset.collaboratorCardInitialMembersValue
      const addBtn = clone.querySelector("[data-collaborator-card-target='addMembersBtn']")
      if (addBtn) { addBtn.classList.add("hidden"); addBtn.classList.remove("inline-flex") }
      // Hide permissions popover in clone
      const permPopover = clone.querySelector("[data-collaborator-card-target='permissionsPopover']")
      if (permPopover) { permPopover.classList.add("hidden"); permPopover.innerHTML = "" }
      container.appendChild(clone)
    }
  }

  async save() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    this._hideErrors()
    this.submitBtnTarget.disabled = true
    this.submitBtnTarget.textContent = "Saving..."

    try {
      const collaborators = this._collectCards()

      const response = await fetch(this.updateUrlValue, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({ collaborators })
      })

      const data = await response.json()

      if (response.ok && data.success) {
        window.location.reload()
      } else {
        this._showErrors(data.errors || ["Update failed"])
        this.submitBtnTarget.disabled = false
        this.submitBtnTarget.textContent = "Save Changes"
      }
    } catch {
      this._showErrors(["A network error occurred. Please try again."])
      this.submitBtnTarget.disabled = false
      this.submitBtnTarget.textContent = "Save Changes"
    }
  }

  _collectCards() {
    const cards = this.collaboratorsContainerTarget.querySelectorAll("[data-controller*='collaborator-card']")
    const result = []

    cards.forEach(card => {
      const companyHidden = card.querySelector("[data-collaborator-card-target='companyHidden']")
      const companyId = companyHidden?.value
      if (!companyId) return

      const chips = card.querySelectorAll("[data-collaborator-card-target='memberChips'] [data-chip-email]")
      const members = Array.from(chips).map(chip => {
        let permissions = []
        try { permissions = JSON.parse(chip.dataset.chipPermissions || "[]") } catch { /* ignore */ }
        return {
          email: chip.dataset.chipEmail,
          permissions,
          is_external: chip.dataset.chipExternal === "true"
        }
      }).filter(m => m.email)

      result.push({ company_id: companyId, members })
    })

    return result
  }

  _showErrors(messages) {
    if (!this.hasErrorsTarget) return
    this.errorsTarget.innerHTML = messages.map(m => `<p>${m}</p>`).join("")
    this.errorsTarget.classList.remove("hidden")
  }

  _hideErrors() {
    if (!this.hasErrorsTarget) return
    this.errorsTarget.classList.add("hidden")
    this.errorsTarget.innerHTML = ""
  }
}
